import $ from 'jquery';
import { onEvent } from '../../util/domutils'; // eslint-disable-line import/named
import { loadContent } from '../../util/fetchutils'; // eslint-disable-line import/named
import { initFlyout } from '../../components/flyoutUnderHeader';

const CONSTANTS = {
  HASH_TRIGGER: 'continuity-flyout',
};

const SELECTORS = {
  FORM: '.continuity-flyout__form',
  CONTAINER: '.continuity-flyout__container',
  PANE: '.continuity-flyout__pane',
};

const handleDisplayOnLoad = (flyoutContainer) => {
  const hash = window.location.hash.replace('#', '');
  const hashParts = hash.split('&');

  if (hashParts.indexOf(CONSTANTS.HASH_TRIGGER) >= 0) {
    $(flyoutContainer).collapse('show');

    // Remove the contnuity flyout trigger from the current hash so it doesn't get opened
    // again on refresh or on attribute change
    const hashNoFlyout = hashParts.filter(part => part !== CONSTANTS.HASH_TRIGGER).join('&');

    window.location.hash = hashNoFlyout;
  }
};

const handleFlyoutContainer = (flyout) => {
  initFlyout(flyout);
  handleDisplayOnLoad(flyout);

  if (!flyout.dataset.initialized) {
    onEvent(flyout, 'submit', SELECTORS.FORM, async (e) => {
      e.preventDefault();

      const { content } = await loadContent(e.delegateTarget);

      let container = document.querySelector(SELECTORS.CONTAINER);
      if (document.querySelector('.product-set-detail .set-items')) {
        container = e.delegateTarget.closest(SELECTORS.CONTAINER);
      }
      container.innerHTML = content;
    });

    flyout.dataset.initialized = 'true';
  }
};

export default () => {
  const flyoutContainer = document.querySelector(SELECTORS.PANE);

  if (flyoutContainer) {
    if (document.querySelector('.product-set-detail .set-items')) {
      const flyoutContainers = document.querySelectorAll(SELECTORS.PANE);
      flyoutContainers.forEach((fc) => {
        handleFlyoutContainer(fc);
      });
    } else {
      handleFlyoutContainer(flyoutContainer);
    }
  }
};
